import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by Hacoba NSA-HS and Taining S41 machines

export default function TensionRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = {target: {value: ""}};

   return (
      <Row className="mb-2">
         <ColPrompt title={"Tension"} bold={true} />
         <ColValue size={2}>
            Min:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.tensionStart || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 100, "tensionStart")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 100, "tensionStart")
               }
            />
            {errorDivDefinitions.tensionStart && <ErrorDiv>0-100 only</ErrorDiv>}
         </ColValue>
         <ColValue size={2}>
            Max:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.tensionEnd || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 100, "tensionEnd")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 100, "tensionEnd")
               }
            />
            {errorDivDefinitions.tensionEnd && <ErrorDiv>0-100 only</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
